import "./AssetManagerProjectCardWithTabsTemplatePills.css";

import { useContext } from "react";

import { MapPinGreyIcon, PrizeBlueIcon, ScaleBlueIcon } from "../../../../assets";
import { ProjectTypeConstants } from "../../../../constants";
import { FileType } from "../../../../models";
import { ProjectContext } from "../../../../route/shared/projects/project/ProjectContext";
import { getIconFromProjectType } from "../../../../utils";
import { OrganisationIcon } from "../../../../widget";

export const AssetManagerProjectCardWithTabsTemplatePills = (): JSX.Element => {
  const { projectDetails, publicProjectDetails } = useContext(ProjectContext);
  const projectDeveloper = projectDetails?.developer.displayName || publicProjectDetails?.developer.displayName;
  const projectDeveloperIcon =
    projectDetails?.developer.files.find((f) => f.type === FileType.SmallLogo)?.file.url ||
    publicProjectDetails?.developer.files.find((f) => f.type === FileType.SmallLogo)?.file.url;

  const projectType = projectDetails?.projectType.displayName || publicProjectDetails?.projectType.displayName;
  const projectTypeUuid = projectDetails?.projectType.uuid || publicProjectDetails?.projectType.uuid;

  const projectCode = projectDetails?.standard.displayName || publicProjectDetails?.standard.displayName;

  const projectRegion = projectDetails?.addressRegion || publicProjectDetails?.addressRegion;

  const projectArea = projectDetails?.areaNetHa || publicProjectDetails?.areaNetHa;
  return (
    <div className="AssetManagerProjectCardWithTabsTemplatePills">
      {/* TODO-JWI: This should be the responsible owner here */}
      {(projectDeveloper || projectDeveloperIcon) && (
        <div className="DeveloperInfo">
          {projectDeveloperIcon && <OrganisationIcon organisationIcon={projectDeveloperIcon} />}
          <p className="body1">{projectDeveloper}</p>
        </div>
      )}
      {projectType && (
        <div
          className="InvestmentProjectCardPill"
          style={{
            color: ProjectTypeConstants.PROJECT_TYPE_PILL_COLOR_MAP[projectType]?.[0],
            backgroundColor: ProjectTypeConstants.PROJECT_TYPE_PILL_COLOR_MAP[projectType]?.[1],
          }}
        >
          {projectTypeUuid && getIconFromProjectType(projectTypeUuid, 14)}
          <span className="body3">{projectType}</span>
        </div>
      )}
      {projectCode && (
        <div className="InvestmentProjectCardPill">
          <PrizeBlueIcon />
          <span className="body3">{projectCode}</span>
        </div>
      )}
      {projectRegion && (
        <div className="InvestmentProjectCardPill">
          <MapPinGreyIcon className="InvestmentProjectCardPillLocation" />
          <span className="body3">{projectRegion}</span>
        </div>
      )}
      {projectArea && (
        <div className="InvestmentProjectCardPill">
          <ScaleBlueIcon />
          <span className="body3">{projectArea} ha</span>
        </div>
      )}
    </div>
  );
};
